import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getFeaturedCaseStudies } from '../../api';
import CaseStudyCard from '../shared/CaseStudyCard';

export default function FeaturedCaseStudies() {
  const [studies, setStudies] = useState([]);

  useEffect(() => {
    getFeaturedCaseStudies().then(setStudies).catch(() => {});
  }, []);

  if (studies.length === 0) return null;

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Client <span className="text-blue-600">Results</span></h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real outcomes for real businesses. Every project is measured by the revenue impact it delivers.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {studies.map(s => <CaseStudyCard key={s.id} study={s} />)}
        </div>
        <div className="text-center mt-12">
          <Link to="/case-studies" className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 py-3 px-8 rounded-full font-medium transition inline-block">
            View All Case Studies
          </Link>
        </div>
      </div>
    </section>
  );
}
